export type BonusActivity = {
  id: string;
  title: string;
  emoji: string;
  summary: string; // 1 sentence
  materials: string[];
  instructions: string[];
};

export const BONUS_ACTIVITIES: BonusActivity[] = [
  {
    id: 'rhythm-ball',
    title: 'Rhythm Ball',
    emoji: '🏐',
    summary: 'Build steady beat, focus, and teamwork by passing a soft ball in time with a metronome.',
    materials: [
      'Very soft ball (dryer ball, hacky sack, or bean bag) — avoid bouncy balls',
      'Metronome (phone/app is fine)',
      'Open space for a circle',
    ],
    instructions: [
      'Form a circle with all students about 1 foot apart.',
      'Set a metronome to ♩=60. Students HAND the ball to their neighbor on each beat so it lands on the beat.',
      'Gradually speed up the metronome and see how fast students can keep it consistent.',
      'Everyone takes 2–3 steps back.',
      'Students toss UNDERHAND to someone across the circle until everyone has had the ball once; repeat a few times so everyone remembers the order.',
      'Set the metronome to ♩=50. Students toss the ball in order while maintaining the beat.',
      'Increase tempo and see how fast the class can safely pass the ball.',
      'Knockout round: if a student does not pass in time, they sit out; as people get knocked out, the circle takes a step in.',
    ],
  },
  {
    id: 'body-shapes',
    title: 'Body Shapes',
    emoji: '🧍',
    summary: 'Practice musical listening by matching iconic song intros with quick, memorable poses.',
    materials: [
      'Short playlist of 5 songs in different genres (iconic intros)',
      'Speaker/audio source',
      'Optional: a few “balance pose” ideas prepared in advance',
    ],
    instructions: [
      'Create a short playlist of 5 songs in different genres with iconic intros (e.g., Take 5, Sweet Child O’ Mine, Bohemian Rhapsody, Hotel California, Take on Me).',
      'With the class, create a pose for each song and practice holding each one (balancing poses are especially fun).',
      'Rotate and randomize the playlist; students must keep up as you switch songs.',
      'Let it get silly and flip through songs quickly once they’ve learned the poses.',
    ],
  },
  {
    id: 'find-my-family',
    title: 'Find My Family!',
    emoji: '🔎',
    summary: 'Reinforce instrument families through a fast-paced “find your group” matching game.',
    materials: [
      'Instrument cards: name + picture (do NOT label the family)',
      'At least 2 cards for each family: Woodwinds, Brass, Percussion, Keyboards, Strings',
      'Space for students to move and form groups',
    ],
    instructions: [
      'Prepare instrument cards with a name and picture (no family labels). Make at least 2 for each family: Woodwinds, Brass, Percussion, Keyboards, Strings.',
      'Give each student one instrument card; they cannot look at it until you say “GO”.',
      'On “GO”, students look and find others in the same instrument family.',
      'First family to correctly gather wins.',
    ],
  },
  {
    id: 'hop-scotch',
    title: 'Hop Scotch',
    emoji: '🦶',
    summary: 'Turn note values into full-body rhythm by hopping and clapping through a hopscotch-style path.',
    materials: [
      'Paper sheets (ideally taped down or laminated)',
      'Markers (to label note values)',
      'Metronome (phone/app is fine)',
      'Open floor space',
      'Optional: laminated 8x11 pages for durability',
    ],
    instructions: [
      'Lay out paper sheets on the ground labeled: Eighth, Quarter, Half, Whole.',
      'Explain each value and how to perform it while moving forward as if playing hopscotch:',
      'Eighth Note: hop from left foot onto right foot.',
      'Quarter Note: one hop on two feet.',
      'Half Note: hop on two feet then clap once.',
      'Whole Note: hop on two feet, clap twice, then one more hop on two feet.',
      'Set a metronome to ♩=60. Arrange the papers in a unique line and demonstrate.',
      'Have everyone try 2–3 times.',
      'Create a new arrangement (students can help), then repeat as many times as you like.',
    ],
  },
  {
    id: 'four-corner-rainstorm',
    title: 'Four Corner Rainstorm',
    emoji: '🌧️',
    summary: 'Layer rhythms by assigning note values to corners and rotating students to create a “rhythm rainstorm.”',
    materials: [
      'Open space with four clear corners',
      'Optional: corner signs labeled Eighth / Quarter / Half / Whole',
    ],
    instructions: [
      'Assign each corner of the room a note value: Eighth, Quarter, Half, Whole.',
      'Have everyone pick a random corner.',
      'Begin by helping the Quarter-note corner clap a consistent beat.',
      'Add the Eighth-note corner, then Half-note corner, then Whole-note corner.',
      'Once everyone is playing correctly, tell one corner to join another and begin clapping the new rhythm.',
      'Next, instruct the students already in that corner to rotate to the next corner.',
      'Do this one corner at a time, then have EVERYONE switch at once for several rotations.',
    ],
  },
  {
    id: 'rhythm-chairs',
    title: 'Rhythm Chairs',
    emoji: '🪑',
    summary: 'Combine movement and note values by switching seats on metronome clicks at different rhythmic rates.',
    materials: [
      'Chairs (about 2× as many as students)',
      'Metronome (phone/app is fine)',
      'Open room with plenty of floor space',
    ],
    instructions: [
      'Place about twice as many chairs as students in a circle and have students sit in every other chair.',
      'Practice: every time you say “SWITCH”, students find another seat (4–5 times) so it’s safe and quick.',
      'Set a metronome to ♩=25 and explain: “This is a quarter note. Find a new seat on every click; the goal is to be seated by the next click.” Practice several rounds.',
      'Increase to ♩=30 and switch to Half Notes: “Find a new seat every TWO clicks.”',
      'Repeat with Whole Notes.',
      'Optional: knockout round (musical chairs style).',
    ],
  },
];


